import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  customerid: [
    {...makeRule('请输入正确的客户ID', 'integer', 'blur', false), min: 1},
  ],
  projectid: [
    {...makeRule('请输入正确的项目ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入配置名称')},
  ],
  title: [
    {...makeRule('请输入虚拟任务标题')},
  ],
  customerid: [
    {...makeRule('请选择客户', 'integer')},
  ],
  projectid: [
    {...makeRule('请选择项目', 'integer')},
  ],
  batchids: [
    {...makeRule('请选择批次', 'array')},
  ],
  radius: [
    {...makeRule('请输入大于0整数', 'integer'), min: 1},
  ],
  max_tsk_cnt: [
    {...makeRule('请输入大于1的整数', 'integer'), min: 1},
  ],
  min_tsk_cnt: [
    {...makeRule('请输入大于1的整数', 'integer'), min: 1},
  ],
  bonus_rate: [
    {...makeRule('请输入非负整数', 'integer'), min: 0},
  ],
  min_finish_cnt: [
    {...makeRule('请输入非负整数', 'integer'), min: 0},
  ],
  point_penalty_rate: [
    {...makeRule('请输入非负整数', 'integer'), min: 0},
  ],
}



// WEBPACK FOOTER //
// ./src/views/midan/midan.rules.js